module.exports = __webpack_public_path__ + "static/img/info_button4_inactive.4709359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_button4_inactive.png
// module id = jGBF
// module chunks = 4